// extracted by mini-css-extract-plugin
var _1 = "Gn2s69rOgokFMrfj_KNW";
export { _1 as "groupLabel" }
